import { mapConfigLoadError } from './appErrors';

/**
 * Fetch `/config.json` and deep-merge with `defaultConfig` (featureFlags merged).
 */
export async function fetchMergedAppConfig(defaultConfig) {
  let response;
  try {
    response = await fetch('/config.json');
  } catch (networkErr) {
    throw mapConfigLoadError(networkErr, null);
  }

  if (!response.ok) {
    throw mapConfigLoadError(new Error(`HTTP ${response.status}`), response);
  }

  let loaded;
  try {
    loaded = await response.json();
  } catch (parseErr) {
    throw mapConfigLoadError(parseErr, response);
  }

  return {
    ...defaultConfig,
    ...loaded,
    featureFlags: {
      ...defaultConfig.featureFlags,
      ...(loaded.featureFlags || {}),
    },
  };
}
